module.exports = __webpack_public_path__ + "img/電気回路_4_8.5c25df50.png";